import { stringArrayToObject } from '../../utils/array';

import { createNewProductQR } from '../../services/ProductServices';

export const actions = stringArrayToObject(
  [
    'LOAD_START',
    'LOAD_SUCCESS',
    'LOAD_FAILURE',
    'HIDE_QR',
  ],
  '@@PRODUCT_QR',
);

const privateActionCreators = {
  loadStart(id) {
    return {
      type: actions.LOAD_START,
      payload: { id },
    };
  },
  loadSuccess(id, qr, qrText) {
    return {
      type: actions.LOAD_SUCCESS,
      payload: { id, qr, qrText },
    };
  },
  loadFailure(id, error) {
    return {
      type: actions.LOAD_FAILURE,
      payload: { id, error },
    };
  },
};

export const actionCreators = {
  createNewProductQR(id) {
    return async (dispatch) => {
      dispatch(privateActionCreators.loadStart(id));
      const response = await createNewProductQR(id);
      if (response.ok) {
        const qr = response.url;
        // Can't make a normal API call because the url is outside the API
        try {
          const textResponse = await fetch(response.url);
          const qrText = await textResponse.text();
          dispatch(privateActionCreators.loadSuccess(id, qr, qrText));
        } catch (e) {
          dispatch(privateActionCreators.loadFailure(id, e.message));
        }
      } else {
        dispatch(privateActionCreators.loadFailure(id, response.error));
      }
    };
  },
  hideProductQR(id) {
    return {
      type: actions.HIDE_QR,
      payload: { id },
    };
  },
};



// WEBPACK FOOTER //
// ./src/redux/ProductQR/actions.js